"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = validate;
exports.normalize = normalize;
exports.format = format;
exports.PIX_KEY_PHONE = exports.PIX_KEY_EMAIL = exports.PIX_KEY_RANDOM = exports.PIX_KEY_CNPJ = exports.PIX_KEY_CPF = void 0;

var _require = require('js-brasil'),
    validateBr = _require.validateBr,
    maskBr = _require.maskBr;

var uuidValidator = require('uuid-validate');

var _require2 = require('libphonenumber-js/mobile'),
    parsePhoneNumber = _require2.parsePhoneNumber,
    isValidPhoneNumber = _require2.isValidPhoneNumber;

var emailValidator = require('email-validator').validate;

var PIX_KEY_CPF = "cpf";
exports.PIX_KEY_CPF = PIX_KEY_CPF;
var PIX_KEY_CNPJ = "cnpj";
exports.PIX_KEY_CNPJ = PIX_KEY_CNPJ;
var PIX_KEY_RANDOM = "random";
exports.PIX_KEY_RANDOM = PIX_KEY_RANDOM;
var PIX_KEY_EMAIL = "email";
exports.PIX_KEY_EMAIL = PIX_KEY_EMAIL;
var PIX_KEY_PHONE = "phone";
/**
 *  
 */

exports.PIX_KEY_PHONE = PIX_KEY_PHONE;

function validate(pixKey) {
  var keyTypes = [];
  pixKey = pixKey.trim();

  if (validateBr.cpf(pixKey)) {
    keyTypes.push(PIX_KEY_CPF);
  }

  if (validateBr.cnpj(pixKey)) {
    keyTypes.push(PIX_KEY_CNPJ);
  }

  if (uuidValidator(pixKey)) {
    keyTypes.push(PIX_KEY_RANDOM);
  }

  if (isValidPhoneNumber(pixKey, 'BR')) {
    keyTypes.push(PIX_KEY_PHONE);
  }

  if (emailValidator(pixKey)) {
    keyTypes.push(PIX_KEY_EMAIL);
  }

  return keyTypes;
}

function normalize(pixKey) {
  var as = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  pixKey = pixKey.trim();
  var useAs = validate(pixKey);

  if (useAs.length > 1) {
    if (useAs.includes(as)) {
      useAs = as;
    } else {
      return null;
    }
  } else if (!useAs.length) {
    return null;
  } else {
    useAs = useAs[0];
  }

  switch (useAs) {
    case PIX_KEY_CPF:
    case PIX_KEY_CNPJ:
      return pixKey.replace(/[^0-9]/g, '');

    case PIX_KEY_RANDOM:
    case PIX_KEY_EMAIL:
      return pixKey;

    case PIX_KEY_PHONE:
      return parsePhoneNumber(pixKey, 'BR').number;
  }
}

function format(pixKey) {
  var as = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  pixKey = normalize(pixKey, as);
  var useAs = validate(pixKey);

  if (useAs.length > 1) {
    if (useAs.includes(as)) {
      useAs = as;
    } else {
      return null;
    }
  } else if (!useAs.length) {
    return null;
  } else {
    useAs = useAs[0];
  }

  switch (useAs) {
    case PIX_KEY_CPF:
      return maskBr.cpf(pixKey);

    case PIX_KEY_CNPJ:
      return maskBr.cnpj(pixKey);

    case PIX_KEY_RANDOM:
    case PIX_KEY_EMAIL:
      return pixKey;

    case PIX_KEY_PHONE:
      var phoneNumber = parsePhoneNumber(pixKey, 'BR');
      return phoneNumber.country === 'BR' ? phoneNumber.formatNational() : phoneNumber.formatInternational();
  }
}